/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, September 8th 2022, 12:13:17 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Stack from "@mui/material/Stack";
import { WorkflowStagesFilterButton } from "service-builder/components/stages/WorkflowStagesFilterButton";
import { OSActionButton } from "ui-widgets";
import { SearchInputWidget } from "ui-widgets/search/SearchInputWidget";
import { WorkflowViewToggler } from "./WorkflowViewToggler";

export const WorkflowBuilderTopBar = ({
  openBPMNTypeSelectorFn,
  handleSearch,
  handleFilterByStage,
  selectedProcessStageId,
  workflowViewType,
  setWorkflowViewType,
}) => {
  return (
    <Stack className="os-task-template-list-editor-top-bar" direction="row" spacing={2}>
      <OSActionButton actionStyle="add" variant="contained" size="small" onClick={openBPMNTypeSelectorFn}>
        Add New
      </OSActionButton>
      <SearchInputWidget extraSearchProps={{ handleSearch }} placeholder_text="Filter Workflow Steps" />
      <WorkflowStagesFilterButton
        handleFilterByStage={handleFilterByStage}
        selectedProcessStageId={selectedProcessStageId}
      />
      <WorkflowViewToggler workflowViewType={workflowViewType} setWorkflowViewType={setWorkflowViewType} />
    </Stack>
  );
};
